import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

type Props<T> = {
  data: T[];
  fetchNextPage: () => void;
  render: (item: T, index: number) => React.ReactNode;
  hasNextPage?: boolean;
};

export function InfiniteGridDisplay<T extends unknown>({
  data,
  fetchNextPage,
  render,
  hasNextPage,
}: Props<T>) {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView) {
      if (hasNextPage) {
        fetchNextPage();
      }
    }
  }, [inView, data, hasNextPage, fetchNextPage]);

  return (
    <section className="grid grid-cols-2 gap-x-16 gap-y-24">
      {data.map((item, index) => render(item, index))}
      <div ref={ref} className="h-24" />
    </section>
  );
}
